export default __webpack_public_path__ + "static/media/489.6d973a8b.png";